const isMac = typeof navigator !== 'undefined' && navigator.platform === 'MacIntel';
export function isMultiplatformCtrlKey(event) {
    return isMac ? event.metaKey : event.ctrlKey;
}
